const countries = [
  {
    "name": "United States",
    "alpha_2_code": "US",
    "alpha_3_code": "USA",
    "abbreviation": "US",
    "numeric_code": "840",
    "es": "Estados Unidos",
    "currency": "USD",
    "capital": "Washington, D.C."
  },
  {
    "name": "Canada",
    "alpha_2_code": "CA",
    "alpha_3_code": "CAN",
    "abbreviation": "CA",
    "numeric_code": "124",
    "es": "Canadá",
    "currency": "CAD",
    "capital": "Ottawa"
  },
  {
    "name": "Afghanistan",
    "alpha_2_code": "AF",
    "alpha_3_code": "AFG",
    "abbreviation": "AF",
    "numeric_code": "004",
    "es": "Afganistán",
    "currency": "AFN",
    "capital": "Kabul"
  },
  {
    "name": "Åland Islands",
    "alpha_2_code": "AX",
    "alpha_3_code": "ALA",
    "abbreviation": "AX",
    "numeric_code": "248",
    "es": "Alandia",
    "currency": "EUR",
    "capital": "Mariehamn"
  },
  {
    "name": "Albania",
    "alpha_2_code": "AL",
    "alpha_3_code": "ALB",
    "abbreviation": "AL",
    "numeric_code": "008",
    "es": "Albania",
    "currency": "ALL",
    "capital": "Tirana"
  },
  {
    "name": "Algeria",
    "alpha_2_code": "DZ",
    "alpha_3_code": "DZA",
    "abbreviation": "DZ",
    "numeric_code": "012",
    "es": "Argelia",
    "currency": "DZD",
    "capital": "Algiers"
  },
  {
    "name": "American Samoa",
    "alpha_2_code": "AS",
    "alpha_3_code": "ASM",
    "abbreviation": "AS",
    "numeric_code": "016",
    "es": "Samoa Americana",
    "currency": "USD",
    "capital": "Pago Pago"
  },
  {
    "name": "Andorra",
    "alpha_2_code": "AD",
    "alpha_3_code": "AND",
    "abbreviation": "AD",
    "numeric_code": "020",
    "es": "Andorra",
    "currency": "EUR",
    "capital": "Andorra la Vella"
  },
  {
    "name": "Angola",
    "alpha_2_code": "AO",
    "alpha_3_code": "AGO",
    "abbreviation": "AO",
    "numeric_code": "024",
    "es": "Angola",
    "currency": "AOA",
    "capital": "Luanda"
  },
  {
    "name": "Anguilla",
    "alpha_2_code": "AI",
    "alpha_3_code": "AIA",
    "abbreviation": "AI",
    "numeric_code": "660",
    "es": "Anguilla",
    "currency": "XCD",
    "capital": "The Valley"
  },
  {
    "name": "Antarctica",
    "alpha_2_code": "AQ",
    "alpha_3_code": "ATA",
    "abbreviation": "AQ",
    "numeric_code": "010",
    "es": "Antártida",
    "currency": "AUD",
    "capital": ""
  },
  {
    "name": "Antigua and Barbuda",
    "alpha_2_code": "AG",
    "alpha_3_code": "ATG",
    "abbreviation": "AG",
    "numeric_code": "028",
    "es": "Antigua y Barbuda",
    "currency": "XCD",
    "capital": "Saint John's"
  },
  {
    "name": "Argentina",
    "alpha_2_code": "AR",
    "alpha_3_code": "ARG",
    "abbreviation": "AR",
    "numeric_code": "032",
    "es": "Argentina",
    "currency": "ARS",
    "capital": "Buenos Aires"
  },
  {
    "name": "Armenia",
    "alpha_2_code": "AM",
    "alpha_3_code": "ARM",
    "abbreviation": "AM",
    "numeric_code": "051",
    "es": "Armenia",
    "currency": "AMD",
    "capital": "Yerevan"
  },
  {
    "name": "Aruba",
    "alpha_2_code": "AW",
    "alpha_3_code": "ABW",
    "abbreviation": "AW",
    "numeric_code": "533",
    "es": "Aruba",
    "currency": "AWG",
    "capital": "Oranjestad"
  },
  {
    "name": "Australia",
    "alpha_2_code": "AU",
    "alpha_3_code": "AUS",
    "abbreviation": "AU",
    "numeric_code": "036",
    "es": "Australia",
    "currency": "AUD",
    "capital": "Canberra"
  },
  {
    "name": "Austria",
    "alpha_2_code": "AT",
    "alpha_3_code": "AUT",
    "abbreviation": "AT",
    "numeric_code": "040",
    "es": "Austria",
    "currency": "EUR",
    "capital": "Vienna"
  },
  {
    "name": "Azerbaijan",
    "alpha_2_code": "AZ",
    "alpha_3_code": "AZE",
    "abbreviation": "AZ",
    "numeric_code": "031",
    "es": "Azerbaiyán",
    "currency": "AZN",
    "capital": "Baku"
  },
  {
    "name": "The Bahamas",
    "alpha_2_code": "BS",
    "alpha_3_code": "BHS",
    "abbreviation": "BS",
    "numeric_code": "044",
    "es": "Bahamas",
    "currency": "BSD",
    "capital": "Nassau"
  },
  {
    "name": "Bahrain",
    "alpha_2_code": "BH",
    "alpha_3_code": "BHR",
    "abbreviation": "BH",
    "numeric_code": "048",
    "es": "Bahrein",
    "currency": "BHD",
    "capital": "Manama"
  },
  {
    "name": "Bangladesh",
    "alpha_2_code": "BD",
    "alpha_3_code": "BGD",
    "abbreviation": "BD",
    "numeric_code": "050",
    "es": "Bangladesh",
    "currency": "BDT",
    "capital": "Dhaka"
  },
  {
    "name": "Barbados",
    "alpha_2_code": "BB",
    "alpha_3_code": "BRB",
    "abbreviation": "BB",
    "numeric_code": "052",
    "es": "Barbados",
    "currency": "BBD",
    "capital": "Bridgetown"
  },
  {
    "name": "Belarus",
    "alpha_2_code": "BY",
    "alpha_3_code": "BLR",
    "abbreviation": "BY",
    "numeric_code": "112",
    "es": "Bielorrusia",
    "currency": "BYR",
    "capital": "Minsk"
  },
  {
    "name": "Belgium",
    "alpha_2_code": "BE",
    "alpha_3_code": "BEL",
    "abbreviation": "BE",
    "numeric_code": "056",
    "es": "Bélgica",
    "currency": "EUR",
    "capital": "Brussels"
  },
  {
    "name": "Belize",
    "alpha_2_code": "BZ",
    "alpha_3_code": "BLZ",
    "abbreviation": "BZ",
    "numeric_code": "084",
    "es": "Belice",
    "currency": "BZD",
    "capital": "Belmopan"
  },
  {
    "name": "Benin",
    "alpha_2_code": "BJ",
    "alpha_3_code": "BEN",
    "abbreviation": "BJ",
    "numeric_code": "204",
    "es": "Benín",
    "currency": "XOF",
    "capital": "Porto-Novo"
  },
  {
    "name": "Bermuda",
    "alpha_2_code": "BM",
    "alpha_3_code": "BMU",
    "abbreviation": "BM",
    "numeric_code": "060",
    "es": "Bermudas",
    "currency": "BMD",
    "capital": "Hamilton"
  },
  {
    "name": "Bhutan",
    "alpha_2_code": "BT",
    "alpha_3_code": "BTN",
    "abbreviation": "BT",
    "numeric_code": "064",
    "es": "Bután",
    "currency": "BTN",
    "capital": "Thimphu"
  },
  {
    "name": "Bolivia",
    "alpha_2_code": "BO",
    "alpha_3_code": "BOL",
    "abbreviation": "BO",
    "numeric_code": "068",
    "es": "Bolivia",
    "currency": "BOB",
    "capital": "Sucre"
  },
  {
    "name": "Bonaire",
    "alpha_2_code": "BQ",
    "alpha_3_code": "BES",
    "abbreviation": "BQ",
    "numeric_code": "535",
    "es": null,
    "currency": "USD",
    "capital": "Kralendijk"
  },
  {
    "name": "Bosnia and Herzegovina",
    "alpha_2_code": "BA",
    "alpha_3_code": "BIH",
    "abbreviation": "BA",
    "numeric_code": "070",
    "es": "Bosnia y Herzegovina",
    "currency": "BAM",
    "capital": "Sarajevo"
  },
  {
    "name": "Botswana",
    "alpha_2_code": "BW",
    "alpha_3_code": "BWA",
    "abbreviation": "BW",
    "numeric_code": "072",
    "es": "Botswana",
    "currency": "BWP",
    "capital": "Gaborone"
  },
  {
    "name": "Bouvet Island",
    "alpha_2_code": "BV",
    "alpha_3_code": "BVT",
    "abbreviation": "BV",
    "numeric_code": "074",
    "es": "Isla Bouvet",
    "currency": "NOK",
    "capital": ""
  },
  {
    "name": "Brazil",
    "alpha_2_code": "BR",
    "alpha_3_code": "BRA",
    "abbreviation": "BR",
    "numeric_code": "076",
    "es": "Brasil",
    "currency": "BRL",
    "capital": "Brasília"
  },
  {
    "name": "British Indian Ocean Territory",
    "alpha_2_code": "IO",
    "alpha_3_code": "IOT",
    "abbreviation": "IO",
    "numeric_code": "086",
    "es": "Territorio Británico del Océano Índico",
    "currency": "USD",
    "capital": "Diego Garcia"
  },
  {
    "name": "United States Minor Outlying Islands",
    "alpha_2_code": "UM",
    "alpha_3_code": "UMI",
    "abbreviation": "UM",
    "numeric_code": "581",
    "es": "Islas Ultramarinas Menores de Estados Unidos",
    "currency": "USD",
    "capital": ""
  },
  {
    "name": "Virgin Islands (British)",
    "alpha_2_code": "VG",
    "alpha_3_code": "VGB",
    "abbreviation": "VG",
    "numeric_code": "092",
    "es": "Islas Vírgenes del Reino Unido",
    "currency": "USD",
    "capital": "Road Town"
  },
  {
    "name": "Virgin Islands (U.S.)",
    "alpha_2_code": "VI",
    "alpha_3_code": "VIR",
    "abbreviation": "VI",
    "numeric_code": "850",
    "es": "Islas Vírgenes de los Estados Unidos",
    "currency": "USD",
    "capital": "Charlotte Amalie"
  },
  {
    "name": "Brunei",
    "alpha_2_code": "BN",
    "alpha_3_code": "BRN",
    "abbreviation": "BN",
    "numeric_code": "096",
    "es": "Brunei",
    "currency": "BND",
    "capital": "Bandar Seri Begawan"
  },
  {
    "name": "Bulgaria",
    "alpha_2_code": "BG",
    "alpha_3_code": "BGR",
    "abbreviation": "BG",
    "numeric_code": "100",
    "es": "Bulgaria",
    "currency": "BGN",
    "capital": "Sofia"
  },
  {
    "name": "Burkina Faso",
    "alpha_2_code": "BF",
    "alpha_3_code": "BFA",
    "abbreviation": "BF",
    "numeric_code": "854",
    "es": "Burkina Faso",
    "currency": "XOF",
    "capital": "Ouagadougou"
  },
  {
    "name": "Burundi",
    "alpha_2_code": "BI",
    "alpha_3_code": "BDI",
    "abbreviation": "BI",
    "numeric_code": "108",
    "es": "Burundi",
    "currency": "BIF",
    "capital": "Bujumbura"
  },
  {
    "name": "Cambodia",
    "alpha_2_code": "KH",
    "alpha_3_code": "KHM",
    "abbreviation": "KH",
    "numeric_code": "116",
    "es": "Camboya",
    "currency": "KHR",
    "capital": "Phnom Penh"
  },
  {
    "name": "Cameroon",
    "alpha_2_code": "CM",
    "alpha_3_code": "CMR",
    "abbreviation": "CM",
    "numeric_code": "120",
    "es": "Camerún",
    "currency": "XAF",
    "capital": "Yaoundé"
  },
  {
    "name": "Cape Verde",
    "alpha_2_code": "CV",
    "alpha_3_code": "CPV",
    "abbreviation": "CV",
    "numeric_code": "132",
    "es": "Cabo Verde",
    "currency": "CVE",
    "capital": "Praia"
  },
  {
    "name": "Cayman Islands",
    "alpha_2_code": "KY",
    "alpha_3_code": "CYM",
    "abbreviation": "KY",
    "numeric_code": "136",
    "es": "Islas Caimán",
    "currency": "KYD",
    "capital": "George Town"
  },
  {
    "name": "Central African Republic",
    "alpha_2_code": "CF",
    "alpha_3_code": "CAF",
    "abbreviation": "CF",
    "numeric_code": "140",
    "es": "República Centroafricana",
    "currency": "XAF",
    "capital": "Bangui"
  },
  {
    "name": "Chad",
    "alpha_2_code": "TD",
    "alpha_3_code": "TCD",
    "abbreviation": "TD",
    "numeric_code": "148",
    "es": "Chad",
    "currency": "XAF",
    "capital": "N'Djamena"
  },
  {
    "name": "Chile",
    "alpha_2_code": "CL",
    "alpha_3_code": "CHL",
    "abbreviation": "CL",
    "numeric_code": "152",
    "es": "Chile",
    "currency": "CLF",
    "capital": "Santiago"
  },
  {
    "name": "China",
    "alpha_2_code": "CN",
    "alpha_3_code": "CHN",
    "abbreviation": "CN",
    "numeric_code": "156",
    "es": "China",
    "currency": "CNY",
    "capital": "Beijing"
  },
  {
    "name": "Christmas Island",
    "alpha_2_code": "CX",
    "alpha_3_code": "CXR",
    "abbreviation": "CX",
    "numeric_code": "162",
    "es": "Isla de Navidad",
    "currency": "AUD",
    "capital": "Flying Fish Cove"
  },
  {
    "name": "Cocos (Keeling) Islands",
    "alpha_2_code": "CC",
    "alpha_3_code": "CCK",
    "abbreviation": "CC",
    "numeric_code": "166",
    "es": "Islas Cocos o Islas Keeling",
    "currency": "AUD",
    "capital": "West Island"
  },
  {
    "name": "Colombia",
    "alpha_2_code": "CO",
    "alpha_3_code": "COL",
    "abbreviation": "CO",
    "numeric_code": "170",
    "es": "Colombia",
    "currency": "COP",
    "capital": "Bogotá"
  },
  {
    "name": "Comoros",
    "alpha_2_code": "KM",
    "alpha_3_code": "COM",
    "abbreviation": "KM",
    "numeric_code": "174",
    "es": "Comoras",
    "currency": "KMF",
    "capital": "Moroni"
  },
  {
    "name": "Republic of the Congo",
    "alpha_2_code": "CG",
    "alpha_3_code": "COG",
    "abbreviation": "CG",
    "numeric_code": "178",
    "es": "Congo",
    "currency": "XAF",
    "capital": "Brazzaville"
  },
  {
    "name": "Democratic Republic of the Congo",
    "alpha_2_code": "CD",
    "alpha_3_code": "COD",
    "abbreviation": "CD",
    "numeric_code": "180",
    "es": "Congo (Rep. Dem.)",
    "currency": "CDF",
    "capital": "Kinshasa"
  },
  {
    "name": "Cook Islands",
    "alpha_2_code": "CK",
    "alpha_3_code": "COK",
    "abbreviation": "CK",
    "numeric_code": "184",
    "es": "Islas Cook",
    "currency": "NZD",
    "capital": "Avarua"
  },
  {
    "name": "Costa Rica",
    "alpha_2_code": "CR",
    "alpha_3_code": "CRI",
    "abbreviation": "CR",
    "numeric_code": "188",
    "es": "Costa Rica",
    "currency": "CRC",
    "capital": "San José"
  },
  {
    "name": "Croatia",
    "alpha_2_code": "HR",
    "alpha_3_code": "HRV",
    "abbreviation": "HR",
    "numeric_code": "191",
    "es": "Croacia",
    "currency": "HRK",
    "capital": "Zagreb"
  },
  {
    "name": "Cuba",
    "alpha_2_code": "CU",
    "alpha_3_code": "CUB",
    "abbreviation": "CU",
    "numeric_code": "192",
    "es": "Cuba",
    "currency": "CUC",
    "capital": "Havana"
  },
  {
    "name": "Curaçao",
    "alpha_2_code": "CW",
    "alpha_3_code": "CUW",
    "abbreviation": "CW",
    "numeric_code": "531",
    "es": null,
    "currency": "ANG",
    "capital": "Willemstad"
  },
  {
    "name": "Cyprus",
    "alpha_2_code": "CY",
    "alpha_3_code": "CYP",
    "abbreviation": "CY",
    "numeric_code": "196",
    "es": "Chipre",
    "currency": "EUR",
    "capital": "Nicosia"
  },
  {
    "name": "Czech Republic",
    "alpha_2_code": "CZ",
    "alpha_3_code": "CZE",
    "abbreviation": "CZ",
    "numeric_code": "203",
    "es": "República Checa",
    "currency": "CZK",
    "capital": "Prague"
  },
  {
    "name": "Denmark",
    "alpha_2_code": "DK",
    "alpha_3_code": "DNK",
    "abbreviation": "DK",
    "numeric_code": "208",
    "es": "Dinamarca",
    "currency": "DKK",
    "capital": "Copenhagen"
  },
  {
    "name": "Djibouti",
    "alpha_2_code": "DJ",
    "alpha_3_code": "DJI",
    "abbreviation": "DJ",
    "numeric_code": "262",
    "es": "Yibuti",
    "currency": "DJF",
    "capital": "Djibouti"
  },
  {
    "name": "Dominica",
    "alpha_2_code": "DM",
    "alpha_3_code": "DMA",
    "abbreviation": "DM",
    "numeric_code": "212",
    "es": "Dominica",
    "currency": "XCD",
    "capital": "Roseau"
  },
  {
    "name": "Dominican Republic",
    "alpha_2_code": "DO",
    "alpha_3_code": "DOM",
    "abbreviation": "DO",
    "numeric_code": "214",
    "es": "República Dominicana",
    "currency": "DOP",
    "capital": "Santo Domingo"
  },
  {
    "name": "Ecuador",
    "alpha_2_code": "EC",
    "alpha_3_code": "ECU",
    "abbreviation": "EC",
    "numeric_code": "218",
    "es": "Ecuador",
    "currency": "USD",
    "capital": "Quito"
  },
  {
    "name": "Egypt",
    "alpha_2_code": "EG",
    "alpha_3_code": "EGY",
    "abbreviation": "EG",
    "numeric_code": "818",
    "es": "Egipto",
    "currency": "EGP",
    "capital": "Cairo"
  },
  {
    "name": "El Salvador",
    "alpha_2_code": "SV",
    "alpha_3_code": "SLV",
    "abbreviation": "SV",
    "numeric_code": "222",
    "es": "El Salvador",
    "currency": "SVC",
    "capital": "San Salvador"
  },
  {
    "name": "Equatorial Guinea",
    "alpha_2_code": "GQ",
    "alpha_3_code": "GNQ",
    "abbreviation": "GQ",
    "numeric_code": "226",
    "es": "Guinea Ecuatorial",
    "currency": "XAF",
    "capital": "Malabo"
  },
  {
    "name": "Eritrea",
    "alpha_2_code": "ER",
    "alpha_3_code": "ERI",
    "abbreviation": "ER",
    "numeric_code": "232",
    "es": "Eritrea",
    "currency": "ERN",
    "capital": "Asmara"
  },
  {
    "name": "Estonia",
    "alpha_2_code": "EE",
    "alpha_3_code": "EST",
    "abbreviation": "EE",
    "numeric_code": "233",
    "es": "Estonia",
    "currency": "EUR",
    "capital": "Tallinn"
  },
  {
    "name": "Ethiopia",
    "alpha_2_code": "ET",
    "alpha_3_code": "ETH",
    "abbreviation": "ET",
    "numeric_code": "231",
    "es": "Etiopía",
    "currency": "ETB",
    "capital": "Addis Ababa"
  },
  {
    "name": "Falkland Islands",
    "alpha_2_code": "FK",
    "alpha_3_code": "FLK",
    "abbreviation": "FK",
    "numeric_code": "238",
    "es": "Islas Malvinas",
    "currency": "FKP",
    "capital": "Stanley"
  },
  {
    "name": "Faroe Islands",
    "alpha_2_code": "FO",
    "alpha_3_code": "FRO",
    "abbreviation": "FO",
    "numeric_code": "234",
    "es": "Islas Faroe",
    "currency": "DKK",
    "capital": "Tórshavn"
  },
  {
    "name": "Fiji",
    "alpha_2_code": "FJ",
    "alpha_3_code": "FJI",
    "abbreviation": "FJ",
    "numeric_code": "242",
    "es": "Fiyi",
    "currency": "FJD",
    "capital": "Suva"
  },
  {
    "name": "Finland",
    "alpha_2_code": "FI",
    "alpha_3_code": "FIN",
    "abbreviation": "FI",
    "numeric_code": "246",
    "es": "Finlandia",
    "currency": "EUR",
    "capital": "Helsinki"
  },
  {
    "name": "France",
    "alpha_2_code": "FR",
    "alpha_3_code": "FRA",
    "abbreviation": "FR",
    "numeric_code": "250",
    "es": "Francia",
    "currency": "EUR",
    "capital": "Paris"
  },
  {
    "name": "French Guiana",
    "alpha_2_code": "GF",
    "alpha_3_code": "GUF",
    "abbreviation": "GF",
    "numeric_code": "254",
    "es": "Guayana Francesa",
    "currency": "EUR",
    "capital": "Cayenne"
  },
  {
    "name": "French Polynesia",
    "alpha_2_code": "PF",
    "alpha_3_code": "PYF",
    "abbreviation": "PF",
    "numeric_code": "258",
    "es": "Polinesia Francesa",
    "currency": "XPF",
    "capital": "Papeetē"
  },
  {
    "name": "French Southern and Antarctic Lands",
    "alpha_2_code": "TF",
    "alpha_3_code": "ATF",
    "abbreviation": "TF",
    "numeric_code": "260",
    "es": "Tierras Australes y Antárticas Francesas",
    "currency": "EUR",
    "capital": "Port-aux-Français"
  },
  {
    "name": "Gabon",
    "alpha_2_code": "GA",
    "alpha_3_code": "GAB",
    "abbreviation": "GA",
    "numeric_code": "266",
    "es": "Gabón",
    "currency": "XAF",
    "capital": "Libreville"
  },
  {
    "name": "The Gambia",
    "alpha_2_code": "GM",
    "alpha_3_code": "GMB",
    "abbreviation": "GM",
    "numeric_code": "270",
    "es": "Gambia",
    "currency": "GMD",
    "capital": "Banjul"
  },
  {
    "name": "Georgia",
    "alpha_2_code": "GE",
    "alpha_3_code": "GEO",
    "abbreviation": "GE",
    "numeric_code": "268",
    "es": "Georgia",
    "currency": "GEL",
    "capital": "Tbilisi"
  },
  {
    "name": "Germany",
    "alpha_2_code": "DE",
    "alpha_3_code": "DEU",
    "abbreviation": "DE",
    "numeric_code": "276",
    "es": "Alemania",
    "currency": "EUR",
    "capital": "Berlin"
  },
  {
    "name": "Ghana",
    "alpha_2_code": "GH",
    "alpha_3_code": "GHA",
    "abbreviation": "GH",
    "numeric_code": "288",
    "es": "Ghana",
    "currency": "GHS",
    "capital": "Accra"
  },
  {
    "name": "Gibraltar",
    "alpha_2_code": "GI",
    "alpha_3_code": "GIB",
    "abbreviation": "GI",
    "numeric_code": "292",
    "es": "Gibraltar",
    "currency": "GIP",
    "capital": "Gibraltar"
  },
  {
    "name": "Greece",
    "alpha_2_code": "GR",
    "alpha_3_code": "GRC",
    "abbreviation": "GR",
    "numeric_code": "300",
    "es": "Grecia",
    "currency": "EUR",
    "capital": "Athens"
  },
  {
    "name": "Greenland",
    "alpha_2_code": "GL",
    "alpha_3_code": "GRL",
    "abbreviation": "GL",
    "numeric_code": "304",
    "es": "Groenlandia",
    "currency": "DKK",
    "capital": "Nuuk"
  },
  {
    "name": "Grenada",
    "alpha_2_code": "GD",
    "alpha_3_code": "GRD",
    "abbreviation": "GD",
    "numeric_code": "308",
    "es": "Grenada",
    "currency": "XCD",
    "capital": "St. George's"
  },
  {
    "name": "Guadeloupe",
    "alpha_2_code": "GP",
    "alpha_3_code": "GLP",
    "abbreviation": "GP",
    "numeric_code": "312",
    "es": "Guadalupe",
    "currency": "EUR",
    "capital": "Basse-Terre"
  },
  {
    "name": "Guam",
    "alpha_2_code": "GU",
    "alpha_3_code": "GUM",
    "abbreviation": "GU",
    "numeric_code": "316",
    "es": "Guam",
    "currency": "USD",
    "capital": "Hagåtña"
  },
  {
    "name": "Guatemala",
    "alpha_2_code": "GT",
    "alpha_3_code": "GTM",
    "abbreviation": "GT",
    "numeric_code": "320",
    "es": "Guatemala",
    "currency": "GTQ",
    "capital": "Guatemala City"
  },
  {
    "name": "Guernsey",
    "alpha_2_code": "GG",
    "alpha_3_code": "GGY",
    "abbreviation": "GG",
    "numeric_code": "831",
    "es": "Guernsey",
    "currency": "GBP",
    "capital": "St. Peter Port"
  },
  {
    "name": "Guinea",
    "alpha_2_code": "GN",
    "alpha_3_code": "GIN",
    "abbreviation": "GN",
    "numeric_code": "324",
    "es": "Guinea",
    "currency": "GNF",
    "capital": "Conakry"
  },
  {
    "name": "Guinea-Bissau",
    "alpha_2_code": "GW",
    "alpha_3_code": "GNB",
    "abbreviation": "GW",
    "numeric_code": "624",
    "es": "Guinea-Bisáu",
    "currency": "XOF",
    "capital": "Bissau"
  },
  {
    "name": "Guyana",
    "alpha_2_code": "GY",
    "alpha_3_code": "GUY",
    "abbreviation": "GY",
    "numeric_code": "328",
    "es": "Guyana",
    "currency": "GYD",
    "capital": "Georgetown"
  },
  {
    "name": "Haiti",
    "alpha_2_code": "HT",
    "alpha_3_code": "HTI",
    "abbreviation": "HT",
    "numeric_code": "332",
    "es": "Haiti",
    "currency": "HTG",
    "capital": "Port-au-Prince"
  },
  {
    "name": "Heard Island and McDonald Islands",
    "alpha_2_code": "HM",
    "alpha_3_code": "HMD",
    "abbreviation": "HM",
    "numeric_code": "334",
    "es": "Islas Heard y McDonald",
    "currency": "AUD",
    "capital": ""
  },
  {
    "name": "Holy See",
    "alpha_2_code": "VA",
    "alpha_3_code": "VAT",
    "abbreviation": "VA",
    "numeric_code": null,
    "es": "Santa Sede",
    "currency": "EUR",
    "capital": "Rome"
  },
  {
    "name": "Honduras",
    "alpha_2_code": "HN",
    "alpha_3_code": "HND",
    "abbreviation": "HN",
    "numeric_code": "340",
    "es": "Honduras",
    "currency": "HNL",
    "capital": "Tegucigalpa"
  },
  {
    "name": "Hong Kong",
    "alpha_2_code": "HK",
    "alpha_3_code": "HKG",
    "abbreviation": "HK",
    "numeric_code": "344",
    "es": "Hong Kong",
    "currency": "HKD",
    "capital": "City of Victoria"
  },
  {
    "name": "Hungary",
    "alpha_2_code": "HU",
    "alpha_3_code": "HUN",
    "abbreviation": "HU",
    "numeric_code": "348",
    "es": "Hungría",
    "currency": "HUF",
    "capital": "Budapest"
  },
  {
    "name": "Iceland",
    "alpha_2_code": "IS",
    "alpha_3_code": "ISL",
    "abbreviation": "IS",
    "numeric_code": "352",
    "es": "Islandia",
    "currency": "ISK",
    "capital": "Reykjavík"
  },
  {
    "name": "India",
    "alpha_2_code": "IN",
    "alpha_3_code": "IND",
    "abbreviation": "IN",
    "numeric_code": "356",
    "es": "India",
    "currency": "INR",
    "capital": "New Delhi"
  },
  {
    "name": "Indonesia",
    "alpha_2_code": "ID",
    "alpha_3_code": "IDN",
    "abbreviation": "ID",
    "numeric_code": "360",
    "es": "Indonesia",
    "currency": "IDR",
    "capital": "Jakarta"
  },
  {
    "name": "Ivory Coast",
    "alpha_2_code": "CI",
    "alpha_3_code": "CIV",
    "abbreviation": "CI",
    "numeric_code": "384",
    "es": "Costa de Marfil",
    "currency": "XOF",
    "capital": "Yamoussoukro"
  },
  {
    "name": "Iran",
    "alpha_2_code": "IR",
    "alpha_3_code": "IRN",
    "abbreviation": "IR",
    "numeric_code": "364",
    "es": "Iran",
    "currency": "IRR",
    "capital": "Tehran"
  },
  {
    "name": "Iraq",
    "alpha_2_code": "IQ",
    "alpha_3_code": "IRQ",
    "abbreviation": "IQ",
    "numeric_code": "368",
    "es": "Irak",
    "currency": "IQD",
    "capital": "Baghdad"
  },
  {
    "name": "Republic of Ireland",
    "alpha_2_code": "IE",
    "alpha_3_code": "IRL",
    "abbreviation": "IE",
    "numeric_code": "372",
    "es": "Irlanda",
    "currency": "EUR",
    "capital": "Dublin"
  },
  {
    "name": "Isle of Man",
    "alpha_2_code": "IM",
    "alpha_3_code": "IMN",
    "abbreviation": "IM",
    "numeric_code": "833",
    "es": "Isla de Man",
    "currency": "GBP",
    "capital": "Douglas"
  },
  {
    "name": "Israel",
    "alpha_2_code": "IL",
    "alpha_3_code": "ISR",
    "abbreviation": "IL",
    "numeric_code": "376",
    "es": "Israel",
    "currency": "ILS",
    "capital": "Jerusalem"
  },
  {
    "name": "Italy",
    "alpha_2_code": "IT",
    "alpha_3_code": "ITA",
    "abbreviation": "IT",
    "numeric_code": "380",
    "es": "Italia",
    "currency": "EUR",
    "capital": "Rome"
  },
  {
    "name": "Jamaica",
    "alpha_2_code": "JM",
    "alpha_3_code": "JAM",
    "abbreviation": "JM",
    "numeric_code": "388",
    "es": "Jamaica",
    "currency": "JMD",
    "capital": "Kingston"
  },
  {
    "name": "Japan",
    "alpha_2_code": "JP",
    "alpha_3_code": "JPN",
    "abbreviation": "JP",
    "numeric_code": "392",
    "es": "Japón",
    "currency": "JPY",
    "capital": "Tokyo"
  },
  {
    "name": "Jersey",
    "alpha_2_code": "JE",
    "alpha_3_code": "JEY",
    "abbreviation": "JE",
    "numeric_code": "832",
    "es": "Jersey",
    "currency": "GBP",
    "capital": "Saint Helier"
  },
  {
    "name": "Jordan",
    "alpha_2_code": "JO",
    "alpha_3_code": "JOR",
    "abbreviation": "JO",
    "numeric_code": "400",
    "es": "Jordania",
    "currency": "JOD",
    "capital": "Amman"
  },
  {
    "name": "Kazakhstan",
    "alpha_2_code": "KZ",
    "alpha_3_code": "KAZ",
    "abbreviation": "KZ",
    "numeric_code": "398",
    "es": "Kazajistán",
    "currency": "KZT",
    "capital": "Astana"
  },
  {
    "name": "Kenya",
    "alpha_2_code": "KE",
    "alpha_3_code": "KEN",
    "abbreviation": "KE",
    "numeric_code": "404",
    "es": "Kenia",
    "currency": "KES",
    "capital": "Nairobi"
  },
  {
    "name": "Kiribati",
    "alpha_2_code": "KI",
    "alpha_3_code": "KIR",
    "abbreviation": "KI",
    "numeric_code": "296",
    "es": "Kiribati",
    "currency": "AUD",
    "capital": "South Tarawa"
  },
  {
    "name": "Kuwait",
    "alpha_2_code": "KW",
    "alpha_3_code": "KWT",
    "abbreviation": "KW",
    "numeric_code": "414",
    "es": "Kuwait",
    "currency": "KWD",
    "capital": "Kuwait City"
  },
  {
    "name": "Kyrgyzstan",
    "alpha_2_code": "KG",
    "alpha_3_code": "KGZ",
    "abbreviation": "KG",
    "numeric_code": "417",
    "es": "Kirguizistán",
    "currency": "KGS",
    "capital": "Bishkek"
  },
  {
    "name": "Laos",
    "alpha_2_code": "LA",
    "alpha_3_code": "LAO",
    "abbreviation": "LA",
    "numeric_code": "418",
    "es": "Laos",
    "currency": "LAK",
    "capital": "Vientiane"
  },
  {
    "name": "Latvia",
    "alpha_2_code": "LV",
    "alpha_3_code": "LVA",
    "abbreviation": "LV",
    "numeric_code": "428",
    "es": "Letonia",
    "currency": "EUR",
    "capital": "Riga"
  },
  {
    "name": "Lebanon",
    "alpha_2_code": "LB",
    "alpha_3_code": "LBN",
    "abbreviation": "LB",
    "numeric_code": "422",
    "es": "Líbano",
    "currency": "LBP",
    "capital": "Beirut"
  },
  {
    "name": "Lesotho",
    "alpha_2_code": "LS",
    "alpha_3_code": "LSO",
    "abbreviation": "LS",
    "numeric_code": "426",
    "es": "Lesotho",
    "currency": "LSL",
    "capital": "Maseru"
  },
  {
    "name": "Liberia",
    "alpha_2_code": "LR",
    "alpha_3_code": "LBR",
    "abbreviation": "LR",
    "numeric_code": "430",
    "es": "Liberia",
    "currency": "LRD",
    "capital": "Monrovia"
  },
  {
    "name": "Libya",
    "alpha_2_code": "LY",
    "alpha_3_code": "LBY",
    "abbreviation": "LY",
    "numeric_code": "434",
    "es": "Libia",
    "currency": "LYD",
    "capital": "Tripoli"
  },
  {
    "name": "Liechtenstein",
    "alpha_2_code": "LI",
    "alpha_3_code": "LIE",
    "abbreviation": "LI",
    "numeric_code": "438",
    "es": "Liechtenstein",
    "currency": "CHF",
    "capital": "Vaduz"
  },
  {
    "name": "Lithuania",
    "alpha_2_code": "LT",
    "alpha_3_code": "LTU",
    "abbreviation": "LT",
    "numeric_code": "440",
    "es": "Lituania",
    "currency": "EUR",
    "capital": "Vilnius"
  },
  {
    "name": "Luxembourg",
    "alpha_2_code": "LU",
    "alpha_3_code": "LUX",
    "abbreviation": "LU",
    "numeric_code": "442",
    "es": "Luxemburgo",
    "currency": "EUR",
    "capital": "Luxembourg"
  },
  {
    "name": "Macau",
    "alpha_2_code": "MO",
    "alpha_3_code": "MAC",
    "abbreviation": "MO",
    "numeric_code": "446",
    "es": "Macao",
    "currency": "MOP",
    "capital": ""
  },
  {
    "name": "Republic of Macedonia",
    "alpha_2_code": "MK",
    "alpha_3_code": "MKD",
    "abbreviation": "MK",
    "numeric_code": "807",
    "es": "Macedonia",
    "currency": "MKD",
    "capital": "Skopje"
  },
  {
    "name": "Madagascar",
    "alpha_2_code": "MG",
    "alpha_3_code": "MDG",
    "abbreviation": "MG",
    "numeric_code": "450",
    "es": "Madagascar",
    "currency": "MGA",
    "capital": "Antananarivo"
  },
  {
    "name": "Malawi",
    "alpha_2_code": "MW",
    "alpha_3_code": "MWI",
    "abbreviation": "MW",
    "numeric_code": "454",
    "es": "Malawi",
    "currency": "MWK",
    "capital": "Lilongwe"
  },
  {
    "name": "Malaysia",
    "alpha_2_code": "MY",
    "alpha_3_code": "MYS",
    "abbreviation": "MY",
    "numeric_code": "458",
    "es": "Malasia",
    "currency": "MYR",
    "capital": "Kuala Lumpur"
  },
  {
    "name": "Maldives",
    "alpha_2_code": "MV",
    "alpha_3_code": "MDV",
    "abbreviation": "MV",
    "numeric_code": "462",
    "es": "Maldivas",
    "currency": "MVR",
    "capital": "Malé"
  },
  {
    "name": "Mali",
    "alpha_2_code": "ML",
    "alpha_3_code": "MLI",
    "abbreviation": "ML",
    "numeric_code": "466",
    "es": "Mali",
    "currency": "XOF",
    "capital": "Bamako"
  },
  {
    "name": "Malta",
    "alpha_2_code": "MT",
    "alpha_3_code": "MLT",
    "abbreviation": "MT",
    "numeric_code": "470",
    "es": "Malta",
    "currency": "EUR",
    "capital": "Valletta"
  },
  {
    "name": "Marshall Islands",
    "alpha_2_code": "MH",
    "alpha_3_code": "MHL",
    "abbreviation": "MH",
    "numeric_code": "584",
    "es": "Islas Marshall",
    "currency": "USD",
    "capital": "Majuro"
  },
  {
    "name": "Martinique",
    "alpha_2_code": "MQ",
    "alpha_3_code": "MTQ",
    "abbreviation": "MQ",
    "numeric_code": "474",
    "es": "Martinica",
    "currency": "EUR",
    "capital": "Fort-de-France"
  },
  {
    "name": "Mauritania",
    "alpha_2_code": "MR",
    "alpha_3_code": "MRT",
    "abbreviation": "MR",
    "numeric_code": "478",
    "es": "Mauritania",
    "currency": "MRO",
    "capital": "Nouakchott"
  },
  {
    "name": "Mauritius",
    "alpha_2_code": "MU",
    "alpha_3_code": "MUS",
    "abbreviation": "MU",
    "numeric_code": "480",
    "es": "Mauricio",
    "currency": "MUR",
    "capital": "Port Louis"
  },
  {
    "name": "Mayotte",
    "alpha_2_code": "YT",
    "alpha_3_code": "MYT",
    "abbreviation": "YT",
    "numeric_code": "175",
    "es": "Mayotte",
    "currency": "EUR",
    "capital": "Mamoudzou"
  },
  {
    "name": "Mexico",
    "alpha_2_code": "MX",
    "alpha_3_code": "MEX",
    "abbreviation": "MX",
    "numeric_code": "484",
    "es": "México",
    "currency": "MXN",
    "capital": "Mexico City"
  },
  {
    "name": "Federated States of Micronesia",
    "alpha_2_code": "FM",
    "alpha_3_code": "FSM",
    "abbreviation": "FM",
    "numeric_code": "583",
    "es": "Micronesia",
    "currency": "USD",
    "capital": "Palikir"
  },
  {
    "name": "Moldova",
    "alpha_2_code": "MD",
    "alpha_3_code": "MDA",
    "abbreviation": "MD",
    "numeric_code": "498",
    "es": "Moldavia",
    "currency": "MDL",
    "capital": "Chișinău"
  },
  {
    "name": "Monaco",
    "alpha_2_code": "MC",
    "alpha_3_code": "MCO",
    "abbreviation": "MC",
    "numeric_code": "492",
    "es": "Mónaco",
    "currency": "EUR",
    "capital": "Monaco"
  },
  {
    "name": "Mongolia",
    "alpha_2_code": "MN",
    "alpha_3_code": "MNG",
    "abbreviation": "MN",
    "numeric_code": "496",
    "es": "Mongolia",
    "currency": "MNT",
    "capital": "Ulan Bator"
  },
  {
    "name": "Montenegro",
    "alpha_2_code": "ME",
    "alpha_3_code": "MNE",
    "abbreviation": "ME",
    "numeric_code": "499",
    "es": "Montenegro",
    "currency": "EUR",
    "capital": "Podgorica"
  },
  {
    "name": "Montserrat",
    "alpha_2_code": "MS",
    "alpha_3_code": "MSR",
    "abbreviation": "MS",
    "numeric_code": "500",
    "es": "Montserrat",
    "currency": "XCD",
    "capital": "Plymouth"
  },
  {
    "name": "Morocco",
    "alpha_2_code": "MA",
    "alpha_3_code": "MAR",
    "abbreviation": "MA",
    "numeric_code": "504",
    "es": "Marruecos",
    "currency": "MAD",
    "capital": "Rabat"
  },
  {
    "name": "Mozambique",
    "alpha_2_code": "MZ",
    "alpha_3_code": "MOZ",
    "abbreviation": "MZ",
    "numeric_code": "508",
    "es": "Mozambique",
    "currency": "MZN",
    "capital": "Maputo"
  },
  {
    "name": "Myanmar",
    "alpha_2_code": "MM",
    "alpha_3_code": "MMR",
    "abbreviation": "MM",
    "numeric_code": "104",
    "es": "Myanmar",
    "currency": "MMK",
    "capital": "Naypyidaw"
  },
  {
    "name": "Namibia",
    "alpha_2_code": "NA",
    "alpha_3_code": "NAM",
    "abbreviation": "NA",
    "numeric_code": "516",
    "es": "Namibia",
    "currency": "NAD",
    "capital": "Windhoek"
  },
  {
    "name": "Nauru",
    "alpha_2_code": "NR",
    "alpha_3_code": "NRU",
    "abbreviation": "NR",
    "numeric_code": "520",
    "es": "Nauru",
    "currency": "AUD",
    "capital": "Yaren"
  },
  {
    "name": "Nepal",
    "alpha_2_code": "NP",
    "alpha_3_code": "NPL",
    "abbreviation": "NP",
    "numeric_code": "524",
    "es": "Nepal",
    "currency": "NPR",
    "capital": "Kathmandu"
  },
  {
    "name": "Netherlands",
    "alpha_2_code": "NL",
    "alpha_3_code": "NLD",
    "abbreviation": "NL",
    "numeric_code": "528",
    "es": "Países Bajos",
    "currency": "EUR",
    "capital": "Amsterdam"
  },
  {
    "name": "New Caledonia",
    "alpha_2_code": "NC",
    "alpha_3_code": "NCL",
    "abbreviation": "NC",
    "numeric_code": "540",
    "es": "Nueva Caledonia",
    "currency": "XPF",
    "capital": "Nouméa"
  },
  {
    "name": "New Zealand",
    "alpha_2_code": "NZ",
    "alpha_3_code": "NZL",
    "abbreviation": "NZ",
    "numeric_code": "554",
    "es": "Nueva Zelanda",
    "currency": "NZD",
    "capital": "Wellington"
  },
  {
    "name": "Nicaragua",
    "alpha_2_code": "NI",
    "alpha_3_code": "NIC",
    "abbreviation": "NI",
    "numeric_code": "558",
    "es": "Nicaragua",
    "currency": "NIO",
    "capital": "Managua"
  },
  {
    "name": "Niger",
    "alpha_2_code": "NE",
    "alpha_3_code": "NER",
    "abbreviation": "NE",
    "numeric_code": "562",
    "es": "Níger",
    "currency": "XOF",
    "capital": "Niamey"
  },
  {
    "name": "Nigeria",
    "alpha_2_code": "NG",
    "alpha_3_code": "NGA",
    "abbreviation": "NG",
    "numeric_code": "566",
    "es": "Nigeria",
    "currency": "NGN",
    "capital": "Abuja"
  },
  {
    "name": "Niue",
    "alpha_2_code": "NU",
    "alpha_3_code": "NIU",
    "abbreviation": "NU",
    "numeric_code": "570",
    "es": "Niue",
    "currency": "NZD",
    "capital": "Alofi"
  },
  {
    "name": "Norfolk Island",
    "alpha_2_code": "NF",
    "alpha_3_code": "NFK",
    "abbreviation": "NF",
    "numeric_code": "574",
    "es": "Isla de Norfolk",
    "currency": "AUD",
    "capital": "Kingston"
  },
  {
    "name": "North Korea",
    "alpha_2_code": "KP",
    "alpha_3_code": "PRK",
    "abbreviation": "KP",
    "numeric_code": "408",
    "es": "Corea del Norte",
    "currency": "KPW",
    "capital": "Pyongyang"
  },
  {
    "name": "Northern Mariana Islands",
    "alpha_2_code": "MP",
    "alpha_3_code": "MNP",
    "abbreviation": "MP",
    "numeric_code": "580",
    "es": "Islas Marianas del Norte",
    "currency": "USD",
    "capital": "Saipan"
  },
  {
    "name": "Norway",
    "alpha_2_code": "NO",
    "alpha_3_code": "NOR",
    "abbreviation": "NO",
    "numeric_code": "578",
    "es": "Noruega",
    "currency": "NOK",
    "capital": "Oslo"
  },
  {
    "name": "Oman",
    "alpha_2_code": "OM",
    "alpha_3_code": "OMN",
    "abbreviation": "OM",
    "numeric_code": "512",
    "es": "Omán",
    "currency": "OMR",
    "capital": "Muscat"
  },
  {
    "name": "Pakistan",
    "alpha_2_code": "PK",
    "alpha_3_code": "PAK",
    "abbreviation": "PK",
    "numeric_code": "586",
    "es": "Pakistán",
    "currency": "PKR",
    "capital": "Islamabad"
  },
  {
    "name": "Palau",
    "alpha_2_code": "PW",
    "alpha_3_code": "PLW",
    "abbreviation": "PW",
    "numeric_code": "585",
    "es": "Palau",
    "currency": "USD",
    "capital": "Ngerulmud"
  },
  {
    "name": "Palestine",
    "alpha_2_code": "PS",
    "alpha_3_code": "PSE",
    "abbreviation": "PS",
    "numeric_code": "275",
    "es": "Palestina",
    "currency": "ILS",
    "capital": "Ramallah"
  },
  {
    "name": "Panama",
    "alpha_2_code": "PA",
    "alpha_3_code": "PAN",
    "abbreviation": "PA",
    "numeric_code": "591",
    "es": "Panamá",
    "currency": "PAB",
    "capital": "Panama City"
  },
  {
    "name": "Papua New Guinea",
    "alpha_2_code": "PG",
    "alpha_3_code": "PNG",
    "abbreviation": "PG",
    "numeric_code": "598",
    "es": "Papúa Nueva Guinea",
    "currency": "PGK",
    "capital": "Port Moresby"
  },
  {
    "name": "Paraguay",
    "alpha_2_code": "PY",
    "alpha_3_code": "PRY",
    "abbreviation": "PY",
    "numeric_code": "600",
    "es": "Paraguay",
    "currency": "PYG",
    "capital": "Asunción"
  },
  {
    "name": "Peru",
    "alpha_2_code": "PE",
    "alpha_3_code": "PER",
    "abbreviation": "PE",
    "numeric_code": "604",
    "es": "Perú",
    "currency": "PEN",
    "capital": "Lima"
  },
  {
    "name": "Philippines",
    "alpha_2_code": "PH",
    "alpha_3_code": "PHL",
    "abbreviation": "PH",
    "numeric_code": "608",
    "es": "Filipinas",
    "currency": "PHP",
    "capital": "Manila"
  },
  {
    "name": "Pitcairn Islands",
    "alpha_2_code": "PN",
    "alpha_3_code": "PCN",
    "abbreviation": "PN",
    "numeric_code": "612",
    "es": "Islas Pitcairn",
    "currency": "NZD",
    "capital": "Adamstown"
  },
  {
    "name": "Poland",
    "alpha_2_code": "PL",
    "alpha_3_code": "POL",
    "abbreviation": "PL",
    "numeric_code": "616",
    "es": "Polonia",
    "currency": "PLN",
    "capital": "Warsaw"
  },
  {
    "name": "Portugal",
    "alpha_2_code": "PT",
    "alpha_3_code": "PRT",
    "abbreviation": "PT",
    "numeric_code": "620",
    "es": "Portugal",
    "currency": "EUR",
    "capital": "Lisbon"
  },
  {
    "name": "Puerto Rico",
    "alpha_2_code": "PR",
    "alpha_3_code": "PRI",
    "abbreviation": "PR",
    "numeric_code": "630",
    "es": "Puerto Rico",
    "currency": "USD",
    "capital": "San Juan"
  },
  {
    "name": "Qatar",
    "alpha_2_code": "QA",
    "alpha_3_code": "QAT",
    "abbreviation": "QA",
    "numeric_code": "634",
    "es": "Catar",
    "currency": "QAR",
    "capital": "Doha"
  },
  {
    "name": "Republic of Kosovo",
    "alpha_2_code": "XK",
    "alpha_3_code": "KOS",
    "abbreviation": "XK",
    "numeric_code": "780",
    "es": "Kosovo",
    "currency": "EUR",
    "capital": "Pristina"
  },
  {
    "name": "Réunion",
    "alpha_2_code": "RE",
    "alpha_3_code": "REU",
    "abbreviation": "RE",
    "numeric_code": "638",
    "es": "Reunión",
    "currency": "EUR",
    "capital": "Saint-Denis"
  },
  {
    "name": "Romania",
    "alpha_2_code": "RO",
    "alpha_3_code": "ROU",
    "abbreviation": "RO",
    "numeric_code": "642",
    "es": "Rumania",
    "currency": "RON",
    "capital": "Bucharest"
  },
  {
    "name": "Russia",
    "alpha_2_code": "RU",
    "alpha_3_code": "RUS",
    "abbreviation": "RU",
    "numeric_code": "643",
    "es": "Rusia",
    "currency": "RUB",
    "capital": "Moscow"
  },
  {
    "name": "Rwanda",
    "alpha_2_code": "RW",
    "alpha_3_code": "RWA",
    "abbreviation": "RW",
    "numeric_code": "646",
    "es": "Ruanda",
    "currency": "RWF",
    "capital": "Kigali"
  },
  {
    "name": "Saint Barthélemy",
    "alpha_2_code": "BL",
    "alpha_3_code": "BLM",
    "abbreviation": "BL",
    "numeric_code": "652",
    "es": "San Bartolomé",
    "currency": "EUR",
    "capital": "Gustavia"
  },
  {
    "name": "Saint Helena",
    "alpha_2_code": "SH",
    "alpha_3_code": "SHN",
    "abbreviation": "SH",
    "numeric_code": "654",
    "es": "Santa Helena",
    "currency": "SHP",
    "capital": "Jamestown"
  },
  {
    "name": "Saint Kitts and Nevis",
    "alpha_2_code": "KN",
    "alpha_3_code": "KNA",
    "abbreviation": "KN",
    "numeric_code": "659",
    "es": "San Cristóbal y Nieves",
    "currency": "XCD",
    "capital": "Basseterre"
  },
  {
    "name": "Saint Lucia",
    "alpha_2_code": "LC",
    "alpha_3_code": "LCA",
    "abbreviation": "LC",
    "numeric_code": "662",
    "es": "Santa Lucía",
    "currency": "XCD",
    "capital": "Castries"
  },
  {
    "name": "Saint Martin",
    "alpha_2_code": "MF",
    "alpha_3_code": "MAF",
    "abbreviation": "MF",
    "numeric_code": "663",
    "es": "Saint Martin",
    "currency": "EUR",
    "capital": "Marigot"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "alpha_2_code": "PM",
    "alpha_3_code": "SPM",
    "abbreviation": "PM",
    "numeric_code": "666",
    "es": "San Pedro y Miquelón",
    "currency": "EUR",
    "capital": "Saint-Pierre"
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "alpha_2_code": "VC",
    "alpha_3_code": "VCT",
    "abbreviation": "VC",
    "numeric_code": "670",
    "es": "San Vicente y Granadinas",
    "currency": "XCD",
    "capital": "Kingstown"
  },
  {
    "name": "Samoa",
    "alpha_2_code": "WS",
    "alpha_3_code": "WSM",
    "abbreviation": "WS",
    "numeric_code": "882",
    "es": "Samoa",
    "currency": "WST",
    "capital": "Apia"
  },
  {
    "name": "San Marino",
    "alpha_2_code": "SM",
    "alpha_3_code": "SMR",
    "abbreviation": "SM",
    "numeric_code": "674",
    "es": "San Marino",
    "currency": "EUR",
    "capital": "City of San Marino"
  },
  {
    "name": "São Tomé and Príncipe",
    "alpha_2_code": "ST",
    "alpha_3_code": "STP",
    "abbreviation": "ST",
    "numeric_code": "678",
    "es": "Santo Tomé y Príncipe",
    "currency": "STD",
    "capital": "São Tomé"
  },
  {
    "name": "Saudi Arabia",
    "alpha_2_code": "SA",
    "alpha_3_code": "SAU",
    "abbreviation": "SA",
    "numeric_code": "682",
    "es": "Arabia Saudí",
    "currency": "SAR",
    "capital": "Riyadh"
  },
  {
    "name": "Senegal",
    "alpha_2_code": "SN",
    "alpha_3_code": "SEN",
    "abbreviation": "SN",
    "numeric_code": "686",
    "es": "Senegal",
    "currency": "XOF",
    "capital": "Dakar"
  },
  {
    "name": "Serbia",
    "alpha_2_code": "RS",
    "alpha_3_code": "SRB",
    "abbreviation": "RS",
    "numeric_code": "688",
    "es": "Serbia",
    "currency": "RSD",
    "capital": "Belgrade"
  },
  {
    "name": "Seychelles",
    "alpha_2_code": "SC",
    "alpha_3_code": "SYC",
    "abbreviation": "SC",
    "numeric_code": "690",
    "es": "Seychelles",
    "currency": "SCR",
    "capital": "Victoria"
  },
  {
    "name": "Sierra Leone",
    "alpha_2_code": "SL",
    "alpha_3_code": "SLE",
    "abbreviation": "SL",
    "numeric_code": "694",
    "es": "Sierra Leone",
    "currency": "SLL",
    "capital": "Freetown"
  },
  {
    "name": "Singapore",
    "alpha_2_code": "SG",
    "alpha_3_code": "SGP",
    "abbreviation": "SG",
    "numeric_code": "702",
    "es": "Singapur",
    "currency": "SGD",
    "capital": "Singapore"
  },
  {
    "name": "Sint Maarten",
    "alpha_2_code": "SX",
    "alpha_3_code": "SXM",
    "abbreviation": "SX",
    "numeric_code": "534",
    "es": null,
    "currency": "ANG",
    "capital": "Philipsburg"
  },
  {
    "name": "Slovakia",
    "alpha_2_code": "SK",
    "alpha_3_code": "SVK",
    "abbreviation": "SK",
    "numeric_code": "703",
    "es": "República Eslovaca",
    "currency": "EUR",
    "capital": "Bratislava"
  },
  {
    "name": "Slovenia",
    "alpha_2_code": "SI",
    "alpha_3_code": "SVN",
    "abbreviation": "SI",
    "numeric_code": "705",
    "es": "Eslovenia",
    "currency": "EUR",
    "capital": "Ljubljana"
  },
  {
    "name": "Solomon Islands",
    "alpha_2_code": "SB",
    "alpha_3_code": "SLB",
    "abbreviation": "SB",
    "numeric_code": "090",
    "es": "Islas Salomón",
    "currency": "SBD",
    "capital": "Honiara"
  },
  {
    "name": "Somalia",
    "alpha_2_code": "SO",
    "alpha_3_code": "SOM",
    "abbreviation": "SO",
    "numeric_code": "706",
    "es": "Somalia",
    "currency": "SOS",
    "capital": "Mogadishu"
  },
  {
    "name": "South Africa",
    "alpha_2_code": "ZA",
    "alpha_3_code": "ZAF",
    "abbreviation": "ZA",
    "numeric_code": "710",
    "es": "República de Sudáfrica",
    "currency": "ZAR",
    "capital": "Pretoria"
  },
  {
    "name": "South Georgia",
    "alpha_2_code": "GS",
    "alpha_3_code": "SGS",
    "abbreviation": "GS",
    "numeric_code": "239",
    "es": "Islas Georgias del Sur y Sandwich del Sur",
    "currency": "GBP",
    "capital": "King Edward Point"
  },
  {
    "name": "South Korea",
    "alpha_2_code": "KR",
    "alpha_3_code": "KOR",
    "abbreviation": "KR",
    "numeric_code": "410",
    "es": "Corea del Sur",
    "currency": "KRW",
    "capital": "Seoul"
  },
  {
    "name": "South Sudan",
    "alpha_2_code": "SS",
    "alpha_3_code": "SSD",
    "abbreviation": "SS",
    "numeric_code": "728",
    "es": "Sudán del Sur",
    "currency": "SSP",
    "capital": "Juba"
  },
  {
    "name": "Spain",
    "alpha_2_code": "ES",
    "alpha_3_code": "ESP",
    "abbreviation": "ES",
    "numeric_code": "724",
    "es": "España",
    "currency": "EUR",
    "capital": "Madrid"
  },
  {
    "name": "Sri Lanka",
    "alpha_2_code": "LK",
    "alpha_3_code": "LKA",
    "abbreviation": "LK",
    "numeric_code": "144",
    "es": "Sri Lanka",
    "currency": "LKR",
    "capital": "Colombo"
  },
  {
    "name": "Sudan",
    "alpha_2_code": "SD",
    "alpha_3_code": "SDN",
    "abbreviation": "SD",
    "numeric_code": "729",
    "es": "Sudán",
    "currency": "SDG",
    "capital": "Khartoum"
  },
  {
    "name": "Suriname",
    "alpha_2_code": "SR",
    "alpha_3_code": "SUR",
    "abbreviation": "SR",
    "numeric_code": "740",
    "es": "Surinam",
    "currency": "SRD",
    "capital": "Paramaribo"
  },
  {
    "name": "Svalbard and Jan Mayen",
    "alpha_2_code": "SJ",
    "alpha_3_code": "SJM",
    "abbreviation": "SJ",
    "numeric_code": "744",
    "es": "Islas Svalbard y Jan Mayen",
    "currency": "NOK",
    "capital": "Longyearbyen"
  },
  {
    "name": "Swaziland",
    "alpha_2_code": "SZ",
    "alpha_3_code": "SWZ",
    "abbreviation": "SZ",
    "numeric_code": "748",
    "es": "Suazilandia",
    "currency": "SZL",
    "capital": "Lobamba"
  },
  {
    "name": "Sweden",
    "alpha_2_code": "SE",
    "alpha_3_code": "SWE",
    "abbreviation": "SE",
    "numeric_code": "752",
    "es": "Suecia",
    "currency": "SEK",
    "capital": "Stockholm"
  },
  {
    "name": "Switzerland",
    "alpha_2_code": "CH",
    "alpha_3_code": "CHE",
    "abbreviation": "CH",
    "numeric_code": "756",
    "es": "Suiza",
    "currency": "CHE",
    "capital": "Bern"
  },
  {
    "name": "Syria",
    "alpha_2_code": "SY",
    "alpha_3_code": "SYR",
    "abbreviation": "SY",
    "numeric_code": "760",
    "es": "Siria",
    "currency": "SYP",
    "capital": "Damascus"
  },
  {
    "name": "Taiwan",
    "alpha_2_code": "TW",
    "alpha_3_code": "TWN",
    "abbreviation": "TW",
    "numeric_code": "158",
    "es": "Taiwán",
    "currency": "TWD",
    "capital": "Taipei"
  },
  {
    "name": "Tajikistan",
    "alpha_2_code": "TJ",
    "alpha_3_code": "TJK",
    "abbreviation": "TJ",
    "numeric_code": "762",
    "es": "Tayikistán",
    "currency": "TJS",
    "capital": "Dushanbe"
  },
  {
    "name": "Tanzania",
    "alpha_2_code": "TZ",
    "alpha_3_code": "TZA",
    "abbreviation": "TZ",
    "numeric_code": "834",
    "es": "Tanzania",
    "currency": "TZS",
    "capital": "Dodoma"
  },
  {
    "name": "Thailand",
    "alpha_2_code": "TH",
    "alpha_3_code": "THA",
    "abbreviation": "TH",
    "numeric_code": "764",
    "es": "Tailandia",
    "currency": "THB",
    "capital": "Bangkok"
  },
  {
    "name": "East Timor",
    "alpha_2_code": "TL",
    "alpha_3_code": "TLS",
    "abbreviation": "TL",
    "numeric_code": "626",
    "es": "Timor Oriental",
    "currency": "USD",
    "capital": "Dili"
  },
  {
    "name": "Togo",
    "alpha_2_code": "TG",
    "alpha_3_code": "TGO",
    "abbreviation": "TG",
    "numeric_code": "768",
    "es": "Togo",
    "currency": "XOF",
    "capital": "Lomé"
  },
  {
    "name": "Tokelau",
    "alpha_2_code": "TK",
    "alpha_3_code": "TKL",
    "abbreviation": "TK",
    "numeric_code": "772",
    "es": "Islas Tokelau",
    "currency": "NZD",
    "capital": "Fakaofo"
  },
  {
    "name": "Tonga",
    "alpha_2_code": "TO",
    "alpha_3_code": "TON",
    "abbreviation": "TO",
    "numeric_code": "776",
    "es": "Tonga",
    "currency": "TOP",
    "capital": "Nuku'alofa"
  },
  {
    "name": "Trinidad and Tobago",
    "alpha_2_code": "TT",
    "alpha_3_code": "TTO",
    "abbreviation": "TT",
    "numeric_code": "780",
    "es": "Trinidad y Tobago",
    "currency": "TTD",
    "capital": "Port of Spain"
  },
  {
    "name": "Tunisia",
    "alpha_2_code": "TN",
    "alpha_3_code": "TUN",
    "abbreviation": "TN",
    "numeric_code": "788",
    "es": "Túnez",
    "currency": "TND",
    "capital": "Tunis"
  },
  {
    "name": "Turkey",
    "alpha_2_code": "TR",
    "alpha_3_code": "TUR",
    "abbreviation": "TR",
    "numeric_code": "792",
    "es": "Turquía",
    "currency": "TRY",
    "capital": "Ankara"
  },
  {
    "name": "Turkmenistan",
    "alpha_2_code": "TM",
    "alpha_3_code": "TKM",
    "abbreviation": "TM",
    "numeric_code": "795",
    "es": "Turkmenistán",
    "currency": "TMT",
    "capital": "Ashgabat"
  },
  {
    "name": "Turks and Caicos Islands",
    "alpha_2_code": "TC",
    "alpha_3_code": "TCA",
    "abbreviation": "TC",
    "numeric_code": "796",
    "es": "Islas Turks y Caicos",
    "currency": "USD",
    "capital": "Cockburn Town"
  },
  {
    "name": "Tuvalu",
    "alpha_2_code": "TV",
    "alpha_3_code": "TUV",
    "abbreviation": "TV",
    "numeric_code": "798",
    "es": "Tuvalu",
    "currency": "AUD",
    "capital": "Funafuti"
  },
  {
    "name": "Uganda",
    "alpha_2_code": "UG",
    "alpha_3_code": "UGA",
    "abbreviation": "UG",
    "numeric_code": "800",
    "es": "Uganda",
    "currency": "UGX",
    "capital": "Kampala"
  },
  {
    "name": "Ukraine",
    "alpha_2_code": "UA",
    "alpha_3_code": "UKR",
    "abbreviation": "UA",
    "numeric_code": "804",
    "es": "Ucrania",
    "currency": "UAH",
    "capital": "Kiev"
  },
  {
    "name": "United Arab Emirates",
    "alpha_2_code": "AE",
    "alpha_3_code": "ARE",
    "abbreviation": "AE",
    "numeric_code": "784",
    "es": "Emiratos Árabes Unidos",
    "currency": "AED",
    "capital": "Abu Dhabi"
  },
  {
    "name": "United Kingdom",
    "alpha_2_code": "GB",
    "alpha_3_code": "GBR",
    "abbreviation": "GB",
    "numeric_code": "826",
    "es": "Reino Unido",
    "currency": "GBP",
    "capital": "London"
  },
  {
    "name": "Uruguay",
    "alpha_2_code": "UY",
    "alpha_3_code": "URY",
    "abbreviation": "UY",
    "numeric_code": "858",
    "es": "Uruguay",
    "currency": "UYI",
    "capital": "Montevideo"
  },
  {
    "name": "Uzbekistan",
    "alpha_2_code": "UZ",
    "alpha_3_code": "UZB",
    "abbreviation": "UZ",
    "numeric_code": "860",
    "es": "Uzbekistán",
    "currency": "UZS",
    "capital": "Tashkent"
  },
  {
    "name": "Vanuatu",
    "alpha_2_code": "VU",
    "alpha_3_code": "VUT",
    "abbreviation": "VU",
    "numeric_code": "548",
    "es": "Vanuatu",
    "currency": "VUV",
    "capital": "Port Vila"
  },
  {
    "name": "Venezuela",
    "alpha_2_code": "VE",
    "alpha_3_code": "VEN",
    "abbreviation": "VE",
    "numeric_code": "862",
    "es": "Venezuela",
    "currency": "VEF",
    "capital": "Caracas"
  },
  {
    "name": "Vietnam",
    "alpha_2_code": "VN",
    "alpha_3_code": "VNM",
    "abbreviation": "VN",
    "numeric_code": "704",
    "es": "Vietnam",
    "currency": "VND",
    "capital": "Hanoi"
  },
  {
    "name": "Wallis and Futuna",
    "alpha_2_code": "WF",
    "alpha_3_code": "WLF",
    "abbreviation": "WF",
    "numeric_code": "876",
    "es": "Wallis y Futuna",
    "currency": "XPF",
    "capital": "Mata-Utu"
  },
  {
    "name": "Western Sahara",
    "alpha_2_code": "EH",
    "alpha_3_code": "ESH",
    "abbreviation": "EH",
    "numeric_code": "732",
    "es": "Sahara Occidental",
    "currency": "MAD",
    "capital": "El Aaiún"
  },
  {
    "name": "Yemen",
    "alpha_2_code": "YE",
    "alpha_3_code": "YEM",
    "abbreviation": "YE",
    "numeric_code": "887",
    "es": "Yemen",
    "currency": "YER",
    "capital": "Sana'a"
  },
  {
    "name": "Zambia",
    "alpha_2_code": "ZM",
    "alpha_3_code": "ZMB",
    "abbreviation": "ZM",
    "numeric_code": "894",
    "es": "Zambia",
    "currency": "ZMW",
    "capital": "Lusaka"
  },
  {
    "name": "Zimbabwe",
    "alpha_2_code": "ZW",
    "alpha_3_code": "ZWE",
    "abbreviation": "ZW",
    "numeric_code": "716",
    "es": "Zimbabue",
    "currency": "USD",
    "capital": "Harare"
  }
];

export default countries;
